import React from "react";
import {
  ExperienceHero,
  Facilities,
  Hero,
  PlanningReverse,
  Row,
  RowReverse,
  Waiting,
  Welcome,
} from "../components";
import {
  aboutBg,
  aboutImage,
  apartmentHeroImage,
  arenaImage,
  arenaImage2,
  bookingBg,
  bookingBg2,
  cafeImage2,
  cinemaImage,
  cinemaImage2,
  facilityIcon10,
  facilityIcon11,
  facilityIcon12,
  facilityIcon13,
  facilityIcon14,
  facilityIcon21,
  facilityIcon22,
  facilityIcon23,
  facilityIcon24,
  facilityIcon25,
  facilityIcon26,
  facilityIcon27,
  facilityIcon28,
  facilityIcon29,
  facilityIcon30,
  facilityIcon31,
  facilityIcon32,
  facilityIcon33,
  facilityIcon34,
  facilityIcon35,
  facilityIcon36,
  facilityIcon37,
  facilityIcon38,
  hotelImage,
  linkIcon,
  missionImage,
  newAboutImage,
  newPlayIcon,
  newWelcomeImage,
  newWelcomeImage2,
  restaurantImage2,
  roomsImage1,
  roomsImage2,
  roomsImage3,
  roomsImage4,
  roomsImage5,
} from "../assets";
import AboutHero from "../components/AboutHero";
import { useNavigate } from "react-router-dom";
import Amenities from "../components/Amenities";
import Values from "../components/Values";

const ExperiencePage = () => {
  const navigate = useNavigate();

  const styles = {
    backgroundImage: `linear-gradient(#00000080, #00000080), url(${aboutBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };

  const styles2 = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${bookingBg2})`,
    // backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.6)), url(${sliderImages[current].imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };

  return (
    <div className="">
      <AboutHero />
      <div className="flex flex-col-reverse md:flex-row md:px-[100px] px-4 gap-12 items-center mb-8">
        <img src={newAboutImage} alt="" className="md:w-[40%]" />
        <div className="">
          <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-2">
            WELCOME TO THE IMPERIAL <span className="text-transparent stroke-green stroke-2 font-light">
                BY WOSAM APARTMENTS
            </span>
          </h2>
          <p className="text-[#B2B2B2] mb-6 font-barlow">
            Welcome to The Imperial by WosAm Apartments, where comfort meets
            elegance. Nestled in serene neighborhoods across Lagos, Ogun, and
            the Federal Capital Territory, Abuja, our luxury apartments offer a
            unique blend of modern sophistication and homely warmth. Whether
            you're here for business, leisure, or a long-term stay, The Imperial
            provides an unparalleled living experience tailored to meet your
            every need.
          </p>
          {/* <button
                  className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
                  onClick={() => navigate("/booking")}
                >
                  BOOK NOW
                </button> */}
        </div>
      </div>

      {/* <div className="flex md:flex-row-reverse flex-col-reverse md:mx-[100px] md:pl-10 md:pr-0 px-4 md:pt-0 pt-10 gap-12 md:justify-between items-center bg-[#FFF5DF]">
        <img src={missionImage} alt="" className="md:w-[40%]" />
        <div className="">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-2">
            <span className="text-transparent stroke-yellow stroke-2 font-light">
              OUR
            </span>{" "}
            MISSION
          </h2>
          <p className="text-[#B2B2B2] mb-6 font-barlow">
            At The Imperial by WosAm Apartments, our mission is to redefine
            urban living by offering world-class hospitality services that
            exceed our guests' expectations. We are dedicated to creating a
            comfortable and luxurious environment where every detail is designed
            with our residents' well-being in mind.
          </p>
          {/* <button
                  className="md:py-3 py-2 px-6 text-white bg-[#FF9900] font-bold"
                  onClick={() => navigate("/booking")}
                >
                  BOOK NOW
                </button> */}
        {/* </div> */}
      {/* // </div> */} 

      <div className="flex flex-col my-16">
        <div className="w-full flex justify-center">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-10 text-center md:px-0 px-4 uppercase md:w-[50%]">
            Our exclusively luxurious all rooms en-suite apartments:
          </h2>
        </div>
        <div className="grid gap-10 md:px-[100px] px-4">
          <div className="grid md:grid-cols-3 gap-10">
            <div className="relative text-white">
              <img src={roomsImage4} alt="" className="" />
              <div className="absolute bottom-4 left-4 font-barlow">
                <p className="font-semibold">
                  Executive Three Bedroom Apartment
                </p>
              </div>
            </div>
            <div className="relative text-white">
              <img src={roomsImage1} alt="" className="" />
              <div className="absolute bottom-4 left-4 font-barlow">
                <p className="font-semibold">Deluxe Two Bedroom Apartment</p>
              </div>
            </div>
            <div className="relative text-white">
              <img src={roomsImage2} alt="" className="" />
              <div className="absolute bottom-4 left-4 font-barlow">
                <p className="font-semibold">Business One Bedroom Apartment</p>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-10">
            <div className="relative text-white">
              <img src={roomsImage3} alt="" className="" />
              <div className="absolute bottom-4 left-4 font-barlow">
                <p className="font-semibold">Standard One Bedroom Apartment</p>
              </div>
            </div>
            <div className="relative text-white">
              <img src={roomsImage4} alt="" className="" />
              <div className="absolute bottom-4 left-4 font-barlow">
                <p className="font-semibold">Studio Apartment</p>
              </div>
            </div>
            {/* <div className="p-6 border border-[#00A859] rounded-xl">
              <img src={facilityIcon13} alt="" className="w-16" />
              <h4 className="text-[#222222] font-bold font-trajan text-lg my-4">
                State-of-the-Art Facilities
              </h4>
              <p className="text-[#B2B2B2] font-barlow font-light">
                Including a fitness center, swimming pool, driver’s lodge, mini
                mart and a free airport shuttle for your convenience.
              </p>
            </div>
            <div className="p-6 border border-[#00A859] rounded-xl">
              <img src={facilityIcon14} alt="" className="w-16" />
              <h4 className="text-[#222222] font-bold font-trajan text-lg my-4">
                Secured Environment
              </h4>
              <p className="text-[#B2B2B2] font-barlow font-light">
                24/7 security surveillance and access-controlled entry for peace
                of mind.
              </p>
            </div> */}
          </div>
        </div>
      </div>

      <div className="flex flex-col my-16">
        <div className="w-full">
          <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-4 text-center md:px-0 px-4">
            Why Choose The Imperial?
          </h2>
          <div className="w-full text-center flex justify-center">
            <p className="text-[#B2B2B2] mb-12 font-barlow text-lg text-center md:px-0 px-4 md:w-[40%]">
              Our apartments are designed to cater to your lifestyle, security,
              and convenience, Here are our Standout Uniqueness:
            </p>
          </div>
        </div>
        <div className="grid gap-10 md:px-[100px] px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon21} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Free Shuttle Bus from and to Airport
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon22} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Located in the heart of Ikeja GRA
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon23} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                10-15 minutes’ drive to Ikeja City Mall
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon24} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Closer to Cubana and Top Ikeja Lounge
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon25} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Drivers Lodge
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon26} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                24/7 Power Supply
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon27} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Fitness facility in each apartment
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon28} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Private in-house Cinema
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon29} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Fully Equipped Kitchen
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon30} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                24/7 House Keeping services
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon31} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Shared Pool Facility
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon32} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Swift Elevator Services
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon33} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Free and Fast Internet Access
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon34} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Laundry Services
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon35} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Dedicated Smoking Area for smokers
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon36} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Secured Car Park
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon37} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                In-house mini mart
              </h4>
            </div>
            <div className="p-4 border border-[#00A859] rounded-xl flex items-center gap-4">
              <img src={facilityIcon38} alt="" className="w-10" />
              <h4 className="text-[#222222] font-bold font-trajan text-xs">
                Lagos City View form our Balcony
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col my-16">
        <div className="w-full">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-4 text-center md:px-0 px-4">
            <span className="text-transparent stroke-yellow stroke-2 font-light block">
              THE WOSAM EXPERIENCE-{" "}
            </span>{" "}
            MORE THAN JUST APARTMENTS
          </h2>
          <div className="w-full text-center flex justify-center">
            <p className="text-[#B2B2B2] mb-12 font-barlow text-center md:px-0 px-4 md:w-[48%]">
              As part of WosAm Holdings, The Imperial provides access to a range
              of premium hospitality and entertainment services, ensuring that
              our guests have everything they need.
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse md:flex-row md:px-[100px] px-4 gap-12 items-center mb-8">
          <img src={hotelImage} alt="" className="md:w-[40%]" />
          <div className="">
            <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-2">
              WOSAM{" "}
              <span className="text-transparent stroke-green stroke-2 font-light">
                HOTELS
              </span>
            </h2>
            <p className="text-[#B2B2B2] mb-6 font-barlow">
              Our luxury hotels provide an exceptional hospitality experience,
              offering **elegant rooms, fine dining, and top-tier guest
              services**. Whether for a short stay or a long business trip,
              WosAm Hotels delivers comfort and convenience.
            </p>
            <a
              href="https://wosamarena.com/facilities/wosam-hotels"
              target="_blank"
              className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
            >
              LEARN MORE
            </a>
          </div>
        </div>
        <div className="flex md:flex-row-reverse flex-col-reverse md:mx-[100px] md:pl-10 md:pr-0 px-4 md:pt-0 pt-10 gap-12 md:justify-between items-center bg-[#FFF5DF] mb-8">
          <img src={cinemaImage} alt="" className="md:w-[40%]" />
          <div className="">
            <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-2">
              <span className="text-transparent stroke-yellow stroke-2 font-light">
                WOSAM
              </span>{" "}
              CINEMAS
            </h2>
            <p className="text-[#B2B2B2] mb-6 font-barlow">
              For movie lovers, WosAm Cinemas offers an immersive entertainment
              experience with state-of-the-art screens, premium sound quality,
              and luxurious seating. Enjoy the latest blockbusters just minutes
              away from WosAm Hotels, Ago-Iwoye.
            </p>
            <a
              href="https://wosamcinemas.com/"
              target="_blank"
              className="md:py-3 py-2 px-6 text-white bg-[#FF9900] font-bold"
            >
              LEARN MORE
            </a>
          </div>
        </div>
        <div className="flex flex-col-reverse md:flex-row md:px-[100px] px-4 gap-12 items-center mb-8">
          <img src={arenaImage} alt="" className="md:w-[40%]" />
          <div className="">
            <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-2">
              WOSAM{" "}
              <span className="text-transparent stroke-green stroke-2 font-light">
                ARENA
              </span>
            </h2>
            <p className="text-[#B2B2B2] mb-6 font-barlow">
              Looking for a dynamic event space? WosAm Arena is the perfect
              venue for concerts, corporate events, and social gatherings,
              offering world-class facilities and a vibrant atmosphere.
            </p>
            <a
              href="https://wosamarena.com"
              target="_blank"
              className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
            >
              LEARN MORE
            </a>
          </div>
        </div>
      </div> */}

      {/* <div
        style={styles2}
        className="h-[300px] md:mx-[100px] mx-4 flex items-center justify-center mb-16"
      >
        <button
          className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
          onClick={() => navigate("/booking")}
        >
          BOOK NOW
        </button>
      </div> */}

      {/* <div className="md:px-[100px] px-4 mb-16 flex flex-col gap-10">
        <div className="flex md:flex-row flex-col justify-between items-center md:gap-24 gap-10">
          <div className="">
            <p className="text-[#B2B2B2] font-barlow">
            Welcome to The Imperial By WosAm Apartments GRA Ikeja, where comfort meets elegance. Nestled in the serene neighborhood of Ikeja GRA in Lagos, our luxury apartments offer a unique blend of modern sophistication and homely warmth.
            </p>
          </div>
          <img src={newWelcomeImage} alt="" className="md:w-[48%]" />
        </div>
        <div className="flex md:flex-row-reverse flex-col justify-between items-center md:gap-24 gap-12">
          <div className="">
            <p className="text-[#B2B2B2] font-barlow">
            Whether you're here for business, leisure, or a long-term stay, WosAm provides an unparalleled living experience tailored to meet your every need.
            </p>
          </div>
          <img src={newWelcomeImage2} alt="" className="md:w-[48%]" />
        </div>
      </div> */}

      {/* <Values /> */}
      {/* <Amenities /> */}

      {/* <div style={styles} className="flex flex-col justify-center items-center md:h-[450px] h-[350px] md:pt-0 pt-12 md:mx-10">
        <h1 className="md:text-3xl md:leading-[48px] font-trajan text-xl font-bold text-white mb-4 w-[100%] text-center">
          ABOUT WosAm APARTMENTS
        </h1>
        <img src={newPlayIcon} alt="" className='w-[80px] h-[80px]' />
      </div> */}
      {/* <Welcome /> */}
      {/* <Facilities /> */}
      {/* <h3 className="md:text-2xl text-xl font-bold mb-4">Our Values</h3>
      <Row
        hText="Excellence"
        pText="We are committed to delivering the highest quality in every aspect of our services, from our thoughtfully designed apartments to our exceptional customer service."
        bText="RESERVE ROOM"
        imagePicture={arenaImage2}
      />
      <RowReverse
        hText="Integrity"
        pText="Transparency and honesty are at the core of our operations. We believe in building lasting relationships with our guests based on trust."
        bText="RESERVE ROOM"
        imagePicture={cinemaImage2}
      />
      <Row
        hText="Innovation"
        pText="We continually seek new ways to enhance our guests’ experience by incorporating modern amenities and adopting the latest technologies."
        bText="RESERVE ROOM"
        imagePicture={cafeImage2}
      />
      <RowReverse
        hText="Security"
        pText="We have equipped WosAm Luxury Apartments with the latest and most robust security technologies to ensure the safety of our guests."
        bText="RESERVE ROOM"
        imagePicture={restaurantImage2}
      /> */}

      {/* <h3 className="md:text-2xl text-xl font-bold mb-4">Amenities</h3> */}
      {/* Amenities Component */}
      {/* <div className="border border-[#919191] w-full rounded-md p-[80px] flex justify-between mb-10">
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Airport Pick Up/Drop Off</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Gym</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Swimming Pool</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Breakfast</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Fully Equipped Kitchen</p>
        </div>
      </div> */}

      {/* <div className="grid grid-cols-2 gap-10 my-[60px]">
        <div className="md:p-10 p-4 bg-[#EFEFEF] rounded-xl">
          <div className="flex flex-col justify-center bg-white text-black md:px-10 px-4 py-10 rounded-xl">
            <h2 className="md:text-xl text-2xl font-bold">Airport Pick Up/Drop Off</h2>
            <p className="mt-4 mb-6 leading-relaxed">Start and end your journey stress-free with our reliable airport transfer service.</p>
          </div>
        </div>
        <div className=" md:p-10 p-4 bg-[#EFEFEF] rounded-xl">
          <div className="flex flex-col justify-center bg-white text-black md:px-10 px-4 py-10 rounded-xl">
            <h2 className="md:text-xl text-2xl font-bold">Gym</h2>
            <p className="mt-4 mb-6 leading-relaxed">Stay fit and healthy during your stay with access to our fully equipped gym.</p>
          </div>
        </div>
      </div> */}

      {/* <PlanningReverse /> */}
      <div className="px-4 md:px-[100px]">
        <Waiting />
      </div>
    </div>
  );
};

export default ExperiencePage;
